var dynamicRequire = require('../dynamicRequire');
var React = dynamicRequire('react');
var Mssg = dynamicRequire('Mssg.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');

var DoubledoorRackChooser = require('./Dimensions/DoubledoorRackChooser.jsx');
var KeyboardChooser = require('./Dimensions/KeyboardChooser.jsx');
var Alerts = require('./Dimensions/Alerts.jsx');
var ExteriorMeasures = require('./Dimensions/ExteriorMeasures.jsx');
var DimensionsChooser = require('./Dimensions/DimensionsChooser.jsx');
var UnitSwitcher = require('./Dimensions/UnitSwitcher.jsx');

class Dimensions extends React.Component {

    render() {
        return <div className="lr-casefactory-choices-sliders-dimensions dimensions">
            {!this.isKeyboardCase() ? <UnitSwitcher {...this.props} /> : ''}
            <strong className="headline">{this.getHeadline()}</strong>

            <div className="lr-casefactory-choices-sliders sliders">
                {this.determineChooser()}

                {!this.isKeyboardCase() ? <ExteriorMeasures {...this.props} />:''}
                <Alerts {...this.props} />
            </div>
        </div>
    }

    isKeyboardCase() {
        return this.props.case.isKeyboardcase;
    }

    getHeadline() {
        return this.isKeyboardCase() ? <Mssg __key="nc_casefactory.keyboard" /> : <Mssg __key="nc_casefactory.size" />;
    }

    isDoubleDoorRack() {
        return this.props.case.isDoubleDoorRack;
    }

    determineChooser() {
        if(this.isKeyboardCase()){
            return <KeyboardChooser {...this.props} />
        }else if(this.isDoubleDoorRack()){
            return <DoubledoorRackChooser {...this.props} />
        }else{
            return <DimensionsChooser {...this.props} />
        }
    }
}

Dimensions.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};
module.exports = Dimensions;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions.jsx